export const ChevronUpIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.511 22.355 16 11.866l10.489 10.489"
        stroke="currentColor"
        strokeWidth="3.93"
      />
    </svg>
  );
};
